import React, { useEffect } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import Routes from './app/routes';
import request from 'app/api/request';
import ErrorBoundary from 'app/components/ErrorBoundary';
import { QueryClient, QueryClientProvider } from 'react-query';
import Toasts from 'app/Toasts';
import './App.scss';
import config from 'config';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 10000,
    },
  },
});

(() => {
  const { _doRequest } = request;
  request._doRequest = (...args) =>
    _doRequest.apply(request, args).catch((e) => {
      if (e.status === 401) {
        window.location.pathname = config.auth?.loginUrl || '/';
      }
      throw e;
    });
})();
function App() {
  console.log('App.js renders');

  // Prevent the browser from navigating to a file that the user drops outside
  // any registered dropzone (e.g. on the dashboard when the import popover is closed).
  // Dropzones like FileZone call stopPropagation, so handled drops never reach these listeners.
  useEffect(() => {
    const isFileDrag = (e) => e.dataTransfer?.types?.includes('Files');
    const preventFileDefault = (e) => {
      if (isFileDrag(e)) e.preventDefault();
    };
    window.addEventListener('dragover', preventFileDefault);
    window.addEventListener('drop', preventFileDefault);
    return () => {
      window.removeEventListener('dragover', preventFileDefault);
      window.removeEventListener('drop', preventFileDefault);
    };
  }, []);

  return (
    <QueryClientProvider client={queryClient}>
      <ErrorBoundary>
        <Router basename={'/client'}>
          <Routes />
          <Toasts />
        </Router>
      </ErrorBoundary>
    </QueryClientProvider>
  );
}

export default App;
